/**
 * The dialogs the panel's frame opens. One slot, so one at a time: opening
 * another in it unmounts the one open.
 */
export type ShellDialog = "search" | "password" | null;

/**
 * What Ctrl+K leaves open. It opens the search only in an empty slot, since
 * taking the password dialog's would unmount it and throw away a password
 * half typed, and it closes the search again.
 */
export function toggleSearch(open: ShellDialog): ShellDialog {
  if (open === null) return "search";
  return open === "search" ? null : open;
}
